export const SET_ME_DATA = "SET_ME_DATA";
export const CLEAR_ME_DATA = "CLEAR_ME_DATA";

export const setMeData = (data: any) => ({
    type: SET_ME_DATA,
    payload: data,
});

export const clearMeData = () => ({
    type: CLEAR_ME_DATA,
});

const initialState = {
    meData: null,
    paymentList: [],
};

export const authReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ME_DATA:
            return {
                ...state,
                meData: action.payload?.data || null,
                paymentList: action.payload?.payment_list || [],
            };
        case CLEAR_ME_DATA:
            return initialState;
        default:
            return state;
    }
};

/**
 * Returns true if online payment is available.
 * Defaults to true when payment data hasn't been fetched yet (before login),
 * so buttons show as they currently do.
 */
export const hasOnlinePayment = (authState: any): boolean => {
    // If meData hasn't been fetched yet (null), default to showing buttons
    if (!authState?.meData) return true;

    const list = authState?.paymentList;
    if (!list || list.length === 0) return false;

    return list.some(
        (p: any) => p.is_online && p.has_app_key && p.has_secret_key
    );
};
